import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface OncWarningModalData {
  message: string;
}

@Component({
  selector: 'app-one-click-warning-modal',
  templateUrl: './one-click-warning-modal.component.html',
  styleUrls: ['./one-click-warning-modal.component.scss'],
})
export class OneClickWarningModalComponent implements OnInit {
  warningText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: OncWarningModalData,
    private dialog: MatDialogRef<MatDialog>,
  ) {}

  ngOnInit() {
    this.handleModalBackdropClick();
    this.warningText = this.data.message;
  }

  closeModal(): void {
    this.dialog.close();
  }

  private handleModalBackdropClick() {
    this.dialog.backdropClick().subscribe(() => {
      this.closeModal();
    });
  }
}
